export const PER_PAGE = 10;

export const EMPTY_ADV = {
  statuses: [], minAmount: '', maxAmount: '',
  minDelay: '', maxDelay: '', dateFrom: '', dateTo: '',
};

export const STATUS_KEYS = {
  pending:    { variant: 'pending',   key: 'status_pending',   group: 'pending'   },
  paid:       { variant: 'paid',      key: 'status_paid',      group: 'paid'      },
  overdue_30: { variant: 'overdue30', key: 'status_overdue',   group: 'overdue'   },
  overdue_60: { variant: 'overdue60', key: 'status_overdue',   group: 'overdue'   },
  cancelled:  { variant: 'preparing', key: 'status_cancelled', group: 'cancelled' },
  disputed:   { variant: 'disputed',  key: 'status_disputed',  group: 'disputed'  },
};

export const AGED_SEGMENTS = [
  { key: 'nonEchu',   labelKey: 'aged_non_echu',  color: '#0F3D5C' },
  { key: 'days1_30',  labelKey: 'aged_1_30',      color: '#94a3b8' },
  { key: 'days31_60', labelKey: 'aged_31_60',     color: '#f59e0b' },
  { key: 'days60p',   labelKey: 'aged_60p',       color: '#b45309' },
];

export const MODAL_STATUS_OPTIONS = [
  { key: 'pending',  labelKey: 'filter_pending'  },
  { key: 'paid',     labelKey: 'filter_paid'     },
  { key: 'overdue',  labelKey: 'filter_overdue'  },
  { key: 'disputed', labelKey: 'filter_disputed' },
];

export function fmtDate(d, locale) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString(locale === 'en' ? 'en-GB' : 'fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function fmtAmount(amount, currency = 'EUR', locale) {
  if (amount == null) return '—';
  return (
    new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount) +
    ' ' + currency
  );
}
